exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NewPlanSetMain {\n  grid-area: main;\n  padding: 10px;\n  box-sizing: border-box;\n}\n.tempDevelopment {\n  display: grid;\n  position: absolute;\n  background: rgba(255, 255, 255, 0.5);\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  z-index: 1;\n  justify-content: center;\n  align-items: center;\n}\n", ""]);

